export default __webpack_public_path__ + "static/media/os_2.a335402a.mp3";